import { BatchJobExecutionDetails } from '@rygen/rygen-ui/model';

import {
  CsvSpecification,
  DocumentReference,
  DocumentUploadUrlResponse,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'orders/import';

export class OrderImportController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async fetchTemplate(): Promise<Blob> {
    const response = await this.http.get<Blob>('template', {
      responseType: 'blob',
    });
    return response.data;
  }

  async fetchSpecification(): Promise<CsvSpecification> {
    const response = await this.http.get<CsvSpecification>('specification');
    return new CsvSpecification(response.data);
  }

  async getUploadUrl(
    documentReference: DocumentReference,
  ): Promise<DocumentUploadUrlResponse> {
    const response = await this.http.post<DocumentUploadUrlResponse>(
      '/upload-url',
      documentReference,
    );
    return new DocumentUploadUrlResponse(response.data);
  }

  async import(
    fileName: string,
    skipHeaders: boolean,
    clientId: number,
  ): Promise<BatchJobExecutionDetails> {
    const response = await this.http.post<BatchJobExecutionDetails>('', {
      fileName,
      skipHeaders,
      clientId,
    });
    return new BatchJobExecutionDetails(response.data);
  }

  async getImportStatus(jobId: number): Promise<BatchJobExecutionDetails> {
    const response = await this.http.get<BatchJobExecutionDetails>(
      `job/${jobId}`,
    );
    return new BatchJobExecutionDetails(response.data);
  }

  async getErrorDocument(jobId: number): Promise<DocumentReference> {
    const response = await this.http.get<DocumentReference>(
      `job/${jobId}/error-document`,
    );
    return new DocumentReference(response.data);
  }
}
